module.exports = __webpack_public_path__ + "static/media/starbucks-alt-core-card.8f69ef51.jpg";